export default "__VITE_ASSET__DjkwKt2J__"